import { useQueryClient } from '../../lib';
import { getAuthTokenKey, getCollectionsKey, getPageKey, getSpaceKey, getSpacesByIdsKey, getSpacesBySlugsKey, getSpacesKey, } from '../../utils/keys';
import { useSpaceUtil } from '../utils';
const findSpaceInSystemSpaces = (args, queryClient, spaceUtils) => {
    let cachedSpace = null;
    const queries = queryClient.getQueriesData({
        queryKey: getAuthTokenKey(),
    });
    queries === null || queries === void 0 ? void 0 : queries.forEach(query => {
        var _a, _b;
        const queryData = query[1];
        (_b = (_a = queryData === null || queryData === void 0 ? void 0 : queryData.network) === null || _a === void 0 ? void 0 : _a.systemSpaces) === null || _b === void 0 ? void 0 : _b.forEach(space => {
            if ((space === null || space === void 0 ? void 0 : space.id) === args.id ||
                (space === null || space === void 0 ? void 0 : space.slug) === args.slug ||
                spaceUtils.matchPath(space, args.path)) {
                cachedSpace = { ...space, ...cachedSpace };
            }
        });
    });
    return cachedSpace && Object.keys(cachedSpace).length > 0
        ? cachedSpace
        : undefined;
};
const findSpace = (args, queryClient, active, spaceUtils) => {
    let cachedSpace = null;
    const queries = queryClient.getQueriesData({
        queryKey: getSpaceKey(),
        active,
    });
    queries === null || queries === void 0 ? void 0 : queries.forEach(query => {
        const space = query[1];
        if ((space === null || space === void 0 ? void 0 : space.id) === args.id ||
            (space === null || space === void 0 ? void 0 : space.slug) === args.slug ||
            spaceUtils.matchPath(space, args.path)) {
            cachedSpace = { ...space, ...cachedSpace };
        }
    });
    return cachedSpace && Object.keys(cachedSpace).length > 0
        ? cachedSpace
        : undefined;
};
const findSpaceInIds = (args, queryClient, active, spaceUtils) => {
    let cachedSpace = null;
    const queries = queryClient.getQueriesData({
        queryKey: getSpacesByIdsKey(),
        active,
    });
    queries === null || queries === void 0 ? void 0 : queries.forEach(query => {
        const queryData = query[1];
        queryData === null || queryData === void 0 ? void 0 : queryData.forEach(space => {
            if ((space === null || space === void 0 ? void 0 : space.id) === args.id ||
                (space === null || space === void 0 ? void 0 : space.slug) === args.slug ||
                spaceUtils.matchPath(space, args.path)) {
                cachedSpace = { ...space, ...cachedSpace };
            }
        });
    });
    return cachedSpace && Object.keys(cachedSpace).length > 0
        ? cachedSpace
        : undefined;
};
const findSpaceInSlugs = (args, queryClient, active, spaceUtils) => {
    let cachedSpace = null;
    const queries = queryClient.getQueriesData({
        queryKey: getSpacesBySlugsKey(),
        active,
    });
    queries === null || queries === void 0 ? void 0 : queries.forEach(query => {
        const queryData = query[1];
        queryData === null || queryData === void 0 ? void 0 : queryData.forEach(space => {
            if ((space === null || space === void 0 ? void 0 : space.id) === args.id ||
                (space === null || space === void 0 ? void 0 : space.slug) === args.slug ||
                spaceUtils.matchPath(space, args.path)) {
                cachedSpace = { ...space, ...cachedSpace };
            }
        });
    });
    return cachedSpace && Object.keys(cachedSpace).length > 0
        ? cachedSpace
        : undefined;
};
const findSpaceInSpaces = (args, queryClient, active, spaceUtils) => {
    let cachedSpace = null;
    const queries = queryClient.getQueriesData({
        queryKey: getSpacesKey(),
        active,
    });
    queries === null || queries === void 0 ? void 0 : queries.forEach(query => {
        var _a;
        const queryData = query[1];
        (_a = queryData === null || queryData === void 0 ? void 0 : queryData.pages) === null || _a === void 0 ? void 0 : _a.forEach(page => {
            var _a;
            (_a = page === null || page === void 0 ? void 0 : page.nodes) === null || _a === void 0 ? void 0 : _a.forEach(space => {
                if ((space === null || space === void 0 ? void 0 : space.id) === args.id ||
                    (space === null || space === void 0 ? void 0 : space.slug) === args.slug ||
                    spaceUtils.matchPath(space, args.path)) {
                    cachedSpace = { ...space, ...cachedSpace };
                }
            });
        });
    });
    return cachedSpace && Object.keys(cachedSpace).length > 0
        ? cachedSpace
        : undefined;
};
const findSpaceInCollections = (args, queryClient, active, spaceUtils) => {
    let cachedSpace = null;
    const queries = queryClient.getQueriesData({
        queryKey: getCollectionsKey(),
        active,
    });
    queries === null || queries === void 0 ? void 0 : queries.forEach(query => {
        const queryData = query[1];
        queryData === null || queryData === void 0 ? void 0 : queryData.forEach(collection => {
            var _a, _b;
            (_b = (_a = collection === null || collection === void 0 ? void 0 : collection.spaces) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.forEach(space => {
                if ((space === null || space === void 0 ? void 0 : space.id) === args.id ||
                    (space === null || space === void 0 ? void 0 : space.slug) === args.slug ||
                    spaceUtils.matchPath(space, args.path)) {
                    cachedSpace = { ...space, ...cachedSpace };
                }
            });
        });
    });
    return cachedSpace && Object.keys(cachedSpace).length > 0
        ? cachedSpace
        : undefined;
};
const findSpaceInPages = (args, queryClient, active, spaceUtils) => {
    let cachedSpace = null;
    const queries = queryClient.getQueriesData({
        queryKey: getPageKey(),
        active,
    });
    queries === null || queries === void 0 ? void 0 : queries.forEach(query => {
        const page = query[1];
        if (page === null || page === void 0 ? void 0 : page.space) {
            const { space } = page;
            if ((space === null || space === void 0 ? void 0 : space.id) === args.id ||
                (space === null || space === void 0 ? void 0 : space.slug) === args.slug ||
                spaceUtils.matchPath(space, args.path)) {
                cachedSpace = { ...space, ...cachedSpace };
            }
        }
    });
    return cachedSpace && Object.keys(cachedSpace).length > 0
        ? cachedSpace
        : undefined;
};
export const getCachedSpace = (uncleanedArgs, queryClient, spaceUtils) => {
    const systemCandidate = findSpaceInSystemSpaces(uncleanedArgs, queryClient, spaceUtils);
    let args = { ...uncleanedArgs };
    if (systemCandidate && args.path) {
        args = { id: systemCandidate.id };
    }
    const activeCandidates = [
        findSpace(args, queryClient, true, spaceUtils),
        findSpaceInIds(args, queryClient, true, spaceUtils),
        findSpaceInSlugs(args, queryClient, true, spaceUtils),
        findSpaceInSpaces(args, queryClient, true, spaceUtils),
        findSpaceInCollections(args, queryClient, true, spaceUtils),
        findSpaceInPages(args, queryClient, true, spaceUtils),
    ];
    const activeSpace = [systemCandidate, ...activeCandidates].reduce((preValue, candidate) => ({
        ...preValue,
        ...(candidate || {}),
    }));
    if (activeSpace && Object.keys(activeSpace).length)
        return activeSpace;
    const inActiveCandidates = [
        findSpace(args, queryClient, false, spaceUtils),
        findSpaceInIds(args, queryClient, false, spaceUtils),
        findSpaceInSlugs(args, queryClient, false, spaceUtils),
        findSpaceInSpaces(args, queryClient, false, spaceUtils),
        findSpaceInCollections(args, queryClient, false, spaceUtils),
        findSpaceInPages(args, queryClient, false, spaceUtils),
    ];
    const inActiveSpace = inActiveCandidates.reduce((preValue, candidate) => ({
        ...preValue,
        ...(candidate || {}),
    }));
    if (inActiveSpace && Object.keys(inActiveSpace).length)
        return inActiveSpace;
};
export const useCachedSpace = (args) => {
    const queryClient = useQueryClient();
    const spaceUtils = useSpaceUtil();
    return getCachedSpace(args, queryClient, spaceUtils);
};
export const useCachedSpaces = (args) => {
    const queryClient = useQueryClient();
    const spaceUtils = useSpaceUtil();
    return args
        .map(arg => getCachedSpace(arg, queryClient, spaceUtils))
        .filter(space => space);
};
export const spacePostsUpdater = (node) => (sn) => {
    var _a, _b, _c;
    return ({
        ...sn,
        postsCount: (sn === null || sn === void 0 ? void 0 : sn.postsCount) + 1,
        posts: {
            ...sn === null || sn === void 0 ? void 0 : sn.posts,
            totalCount: (((_a = sn === null || sn === void 0 ? void 0 : sn.posts) === null || _a === void 0 ? void 0 : _a.totalCount) || 0) + 1,
            nodes: [node, ...(((_b = sn === null || sn === void 0 ? void 0 : sn.posts) === null || _b === void 0 ? void 0 : _b.nodes) || [])],
            edges: [{ node, cursor: '' }, ...(((_c = sn === null || sn === void 0 ? void 0 : sn.posts) === null || _c === void 0 ? void 0 : _c.edges) || [])],
        },
    });
};
export const infiniteSpaceUpdater = (spaceId, updater) => (paginatedSpaces) => {
    var _a;
    return ({
        ...paginatedSpaces,
        pages: (_a = paginatedSpaces === null || paginatedSpaces === void 0 ? void 0 : paginatedSpaces.pages) === null || _a === void 0 ? void 0 : _a.map(infinitePaginatedSpaceWithRepliesUpdater(spaceId, updater)),
    });
};
export const infinitePaginatedSpaceWithRepliesUpdater = (spaceId, updater) => (spaces) => {
    var _a, _b;
    return {
        ...spaces,
        nodes: (_a = spaces.nodes) === null || _a === void 0 ? void 0 : _a.map(infiniteSpaceArrayUpdater(spaceId, updater)),
        edges: (_b = spaces.edges) === null || _b === void 0 ? void 0 : _b.map(e => {
            let newNode = e.node;
            if (e.node.id === spaceId) {
                newNode = updater(e.node);
            }
            return {
                ...e,
                node: {
                    ...newNode,
                },
            };
        }),
    };
};
export const infiniteSpaceArrayUpdater = (spaceId, updater) => (space) => {
    let newNode = space;
    if (space.id === spaceId) {
        newNode = updater(space);
    }
    return {
        ...newNode,
    };
};
//# sourceMappingURL=useCachedSpace.js.map